import { render, staticRenderFns } from "./bindStore.vue?vue&type=template&id=1d4dd8ac&scoped=true"
import script from "./bindStore.vue?vue&type=script&lang=ts"
export * from "./bindStore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4dd8ac",
  null
  
)

export default component.exports